import React, {Component} from 'react'
import {Link, navigate, withPrefix} from 'gatsby'
import { Dropdown, Menu } from 'semantic-ui-react'
import * as styles from './styles/header.module.css'

export default class UserIcon extends Component {
	render() {
		const {
			token,
			logout,
			activeItem,
			recheckLoggedIn
		} = this.props
		return(
			<React.Fragment>
				{token ? (
					<Dropdown
						className="link item"
						icon="user"
						name="userIcon"
					>
						<Dropdown.Menu className={`${styles.text} ${styles.dropDown}`}>
							<Dropdown.Item
								as={Link}
								to="/my-account/"
								active={activeItem === withPrefix('my-account/')}
							>
								My Account
							</Dropdown.Item>
							<Dropdown.Item
								as={Link}
								to="/my-account/orders"
								active={activeItem === withPrefix('my-account/orders/')}
							>
								Order History
							</Dropdown.Item>
							<Dropdown.Item
								as={Link}
								to="/my-account/payments"
								active={activeItem === withPrefix('my-account/payments/')}
							>
								Payment History
							</Dropdown.Item>
							<Dropdown.Item
								name={"signOutOption"}
								onClick={()=>{
									logout()
									.then(()=>{
										recheckLoggedIn()
										navigate("/")
									}).catch((err)=>{

									})
								}}
							>
								Sign Out
							</Dropdown.Item>

						</Dropdown.Menu>
					</Dropdown>
				):(
					<Menu.Item
						as={Link}
						to="/sign-in/"
					>
						Sign&nbsp;In
					</Menu.Item>
				)}
			</React.Fragment>
		)
	}
}